import type { AccessConstraint } from '@sb/shared/access';
import { featureFlag } from '@sb/shared/feature';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the schedule-settings routes. */
const scheduleBase = { permission: ['Manage account'] } satisfies AccessConstraint;

export const scheduleSettingsAccess = {
  notifications: { ...scheduleBase, subscriptionPlan: PlanType.BASIC },
  'notifications/variation': { ...scheduleBase, subscriptionPlan: PlanType.BASIC },
  'notifications/add-variation': { ...scheduleBase, subscriptionPlan: PlanType.BASIC },
  'custom-fields': { ...scheduleBase, subscriptionPlan: PlanType.PREMIUM },
  availability: { ...scheduleBase, subscriptionPlan: PlanType.PREMIUM },
  'availability/variation': { ...scheduleBase, subscriptionPlan: PlanType.PREMIUM },
  'availability/add-variation': { ...scheduleBase, subscriptionPlan: PlanType.BASIC },
  'auto-scheduling': {
    ...scheduleBase,
    subscriptionPlan: PlanType.PREMIUM,
    featureFlag: featureFlag.TMP_AUTO_SCHEDULING,
  },
} satisfies Record<string, AccessConstraint>;
